import * as React from "react";
import { useCallback } from "react";
import { styled } from "@mui/material";
import { RosebudColorMap } from "../../diagnosticAgent/rosebud/rosebudColorMap";
import { useHistory } from "react-router-dom";
import {
  KAHUN_PLATFORM,
  LOGIN_STAGE,
  LoginWidget,
} from "@kahunmedical/user-management";

//region [[ Styles ]]
const ForgotPasswordView = styled("div")({
  position: "absolute",
  width: "100%",
  height: "100%",
  background: RosebudColorMap.mainBackground,
  display: "flex",
  flexFlow: "column",
  alignItems: "center",
  justifyContent: "center",
});

const NewPassword = styled(LoginWidget)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  marginTop: theme.spacing(1),
  background: "white",
}));
//endregion [[ Styles ]]

//region [[ Props ]]

export interface ForgotPasswordProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ForgotPassword = ({ ...props }: ForgotPasswordProps) => {
  const histoy = useHistory();

  const handlePasswordRest = useCallback(() => {
    histoy.push("/login");
  }, [histoy]);

  return (
    <ForgotPasswordView>
      <NewPassword
        stage={LOGIN_STAGE.ForgotPassword}
        platform={KAHUN_PLATFORM.AGENT}
        loginFormProps={{ onSignIn: null }}
        newPasswordFormProps={{ onNewPasswordComplete: handlePasswordRest }}
      />
    </ForgotPasswordView>
  );
};
